<template>
  <div id="participant_grid_screenshare" v-if="hasScreenShare" class="flex gap-3 min-h-0 h-full p-4">
    <div class="flex-1 min-w-0">
      <ScreenShareTile
        :userId="screenShareUserId"
        :isLocal="screenShareIsLocal"
      />
    </div>
    <div class="flex flex-col gap-3 w-48 overflow-y-auto">
      <ParticipantTile
        :userId="currentUserId"
        :isLocal="true"
        :videoEnabled="videoEnabled"
        :audioEnabled="!isMuted"
        :isSpeaking="isLocalSpeaking"
        :avatarSize="60"
        :avatarFont="20"
      />
      <ParticipantTile
        v-for="p in remoteParticipants"
        :key="p.user_id"
        :userId="p.user_id"
        :videoEnabled="p.video_enabled || false"
        :audioEnabled="!p.muted"
        :isSpeaking="p.speaking || false"
        :avatarSize="60"
        :avatarFont="20"
      />
    </div>
  </div>

  <div id="participant_grid" v-else class="h-full p-6 overflow-y-auto flex items-center justify-center">
    <div
      class="grid gap-4 w-full max-w-3xl"
      :style="{ gridTemplateColumns: `repeat(${gridCols}, 1fr)`, gridAutoRows: '1fr' }"
    >
      <ParticipantTile
        :userId="currentUserId"
        :isLocal="true"
        :videoEnabled="videoEnabled"
        :audioEnabled="!isMuted"
        :isSpeaking="isLocalSpeaking"
      />
      <ParticipantTile
        v-for="p in remoteParticipants"
        :key="p.user_id"
        :userId="p.user_id"
        :videoEnabled="p.video_enabled || false"
        :audioEnabled="!p.muted"
        :isSpeaking="p.speaking || false"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import ParticipantTile from "./ParticipantTile.vue";
import ScreenShareTile from "./ScreenShareTile.vue";

const store = useStore();

const participants = computed(() => store.getters["huddles/participants"]);
const isMuted = computed(() => store.getters["huddles/isMuted"]);
const videoEnabled = computed(() => store.getters["huddles/videoEnabled"]);
const screenSharing = computed(() => store.getters["huddles/screenSharing"]);
const currentUserId = computed(() => store.getters["auth/userData"]?.id);
const activeSpeakerIds = computed(() => store.getters["huddles/activeSpeakerIds"]);

const isLocalSpeaking = computed(() =>
  activeSpeakerIds.value.includes(String(currentUserId.value))
);

const remoteParticipants = computed(() =>
  participants.value.filter((p) => Number(p.user_id) !== Number(currentUserId.value))
);

const screenShareUserId = computed(() => {
  if (screenSharing.value) return currentUserId.value;
  const sharing = participants.value.find((p) => p.screen_sharing);
  return sharing?.user_id || 0;
});

const screenShareIsLocal = computed(() => screenSharing.value);

const hasScreenShare = computed(() => {
  if (screenSharing.value) return true;
  return participants.value.some((p) => p.screen_sharing);
});

const totalCount = computed(() => 1 + remoteParticipants.value.length);

const gridCols = computed(() => {
  if (totalCount.value <= 1) return 1;
  if (totalCount.value <= 4) return 2;
  if (totalCount.value <= 9) return 3;
  return 4;
});
</script>
